import { Pipe, PipeTransform } from '@angular/core';
import { Schema } from '@app/core/_models/schema';

@Pipe({
  name: 'showPropertyArrayHint',
})

export class ShowPropertyArrayHintPipe implements PipeTransform {
  public transform(properties: Schema, controlName: string): string {
    const field = properties.getField(controlName);
    return field.minItems || field.maxItems;
  }
}
